var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quantity-selector"},[_c('div',{staticClass:"control minus",on:{"click":function($event){return _vm.$emit('clickMinus')}}}),_vm._v(" "),_c('div',{staticClass:"amount"},[_vm._v(_vm._s(_vm.amount))]),_vm._v(" "),_c('div',{staticClass:"control plus",on:{"click":function($event){return _vm.$emit('clickPlus')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QuantitySelector.vue?vue&type=template&id=43d55a60&
// module id = 721
// module chunks = 2